import React, { FunctionComponent } from 'react'
import cx from 'classnames'
import BusyContainer from '@src/components/busy.line'
import * as styles from './header.styl'
import SearchControlContainer from '../search.control'
import FilterContainer from '@src/components/head.filter'
import ProfileSettings from '../profile.settings'
import type { History } from 'history'
import AboutUs from '../about'
import { useFeatureFlagsContext } from '../../../feature.flags/context'
import WaitFeatureFlagContext from '@src/modules/feature.flags/components/wait.feature.flag.context'

export interface HeaderProps {
  history: History
  handleCollapse: () => void
  sidebarCollapsed: boolean
}

const Header: FunctionComponent<HeaderProps> = ({
  history,
  handleCollapse,
  sidebarCollapsed
}: React.PropsWithChildren<HeaderProps>) => {
  const [showAboutUs, setShowAboutUs] = React.useState<boolean>(false)
  const { CAM_PERM_20220804_HIDE_AUTOCOMPLETE } = useFeatureFlagsContext()
  const hideAutocomplete = CAM_PERM_20220804_HIDE_AUTOCOMPLETE?.response?.value

  const onCloseAboutUs = () => {
    setShowAboutUs(false)
  }
  const onOpenAboutUs = () => {
    setShowAboutUs(true)
  }

  return (
    <div className={cx(styles.header, { collapsed: sidebarCollapsed })}>
      <div className={styles.leftMenu}>
        <span className={styles.toggleSidebar} onClick={handleCollapse}>
          <i className="material-icons">menu</i>
        </span>
        <WaitFeatureFlagContext
          hideSpinner
          flag={'CAM_PERM_20220804_HIDE_ALL_SOURCE'}
        >
          {({ response, pending }) => {
            return !pending && !response?.value ? (
              <>
                {' '}
                {!hideAutocomplete && (
                  <SearchControlContainer history={history} />
                )}
              </>
            ) : (
              <></>
            )
          }}
        </WaitFeatureFlagContext>
      </div>
      <div className={styles.rightMenu}>
        <WaitFeatureFlagContext
          hideSpinner
          flag={'CAM_PERM_20220804_HIDE_ALL_SOURCE'}
        >
          {({ pending, response }) => {
            return !pending && !response?.value ? (
              <FilterContainer history={history} />
            ) : (
              <></>
            )
          }}
        </WaitFeatureFlagContext>
        {
          //<Notifications />
        }

        <ProfileSettings onOpenAboutUs={onOpenAboutUs} history={history} />
        <AboutUs open={showAboutUs} onClose={onCloseAboutUs} />
      </div>
      <BusyContainer />
    </div>
  )
}

export default Header
